/**
 * @author gll
 * 功能：属性模块
 */
import { Service } from '@/tools'

export class AttributeService<T extends TCommodity.Attribute> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Attribute}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  //属性列表(类目中调用)
  // /api/commodity/attribute/v1/attributePage
  attributePage = <K extends T['ApiAttributePage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAttributePage', data)

  // attributePageList
  //属性列表
  // /api/commodity/attribute/v1/pageList
  pageList = <K extends T['ApiPageList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageList', data)

  //增加属性
  // /api/commodity/attribute/v1/addCommodityAttribute
  addCommodityAttribute = <K extends T['ApiAddCommodityAttribute']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiAddCommodityAttribute', data)

  //修改属性
  // /api/commodity/attribute/v1/updateCommodityAttribute
  updateCommodityAttribute = <K extends T['ApiUpdateCommodityAttribute']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiUpdateCommodityAttribute', data)

  //删除属性值
  // /api/commodity/attribute/v1/deleteCommodityAttributeScopeValue
  deleteCommodityAttributeScopeValue = <K extends T['ApiDeleteCommodityAttributeScopeValue']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiDeleteCommodityAttributeScopeValue', data)

  //属性详情
  // /api/commodity/attribute/v1/selectCommodityAttributeById
  selectCommodityAttributeById = <K extends T['ApiSelectCommodityAttributeById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectCommodityAttributeById', data)

  //禁用属性
  // /api/commodity/attribute/v1/disableCommodityAttribute
  disableCommodityAttribute = <K extends T['ApiDisableCommodityAttribute']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiDisableCommodityAttribute', data)

  //启用属性
  // /api/commodity/attribute/v1/enableCommodityAttribute
  enableCommodityAttribute = <K extends T['ApiEnableCommodityAttribute']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiEnableCommodityAttribute', data)

  //删除属性
  // /api/commodity/attribute/v1/deleteCommodityAttribute
  deleteCommodityAttribute = <K extends T['ApiDeleteCommodityAttribute']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiDeleteCommodityAttribute', data)

  // 查询属性值分页列表（版次、印次）
  // /api/commodity/attribute/v1/queryAttributeValuePage
  queryAttributeValuePage = <K extends T['ApiQueryAttributeValuePage']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryAttributeValuePage', data)

  // 查询属性模板引用
  // /api/commodity/attribute/v1/queryTemplateCite
  queryTemplateCite = <K extends T['ApiQueryTemplateCite']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryTemplateCite', data)
}
